
import Vue, { PropType } from "vue";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";

export default Vue.extend({
  name: "component-area-view-row",
  props: {
    inputData: {
      type: Object as PropType<
        PortalAdapterApi.TopAreaCountry | PortalAdapterApi.ResponseGetTopArea | PortalAdapterApi.TopArea
      >,
      required: true,
    },
    areaType: {
      type: String as PropType<"prefecture" | "area" | undefined>,
    },
    isLastRow: Boolean,
  },
  data() {
    return {
      childData: undefined as
        | undefined
        | PortalAdapterApi.TopAreaCountry
        | PortalAdapterApi.ResponseGetTopArea
        | PortalAdapterApi.TopArea,
    };
  },
  computed: {
    displayText(): string | undefined {
      if (this.childData === undefined) return;
      return this.childData.displayText;
    },
    countryName(): string | undefined {
      return this.countryData?.countryName;
    },
    prefectureName(): string | undefined {
      return this.prefectureData?.areaGroupName;
    },
    countryData(): undefined | PortalAdapterApi.TopAreaCountry {
      if (this.childData === undefined) return;
      if ((<PortalAdapterApi.TopAreaCountry>this.childData).countryName !== undefined) {
        return this.childData as PortalAdapterApi.TopAreaCountry;
      }
      return undefined;
    },
    prefectureData(): undefined | PortalAdapterApi.ResponseGetTopArea {
      if (this.childData === undefined) return;
      if ((<PortalAdapterApi.ResponseGetTopArea>this.childData).areaGroupName !== undefined) {
        return this.childData as PortalAdapterApi.ResponseGetTopArea;
      }
      return undefined;
    },
    areaData(): undefined | PortalAdapterApi.TopArea {
      if (this.childData === undefined) return;
      if ((<PortalAdapterApi.TopArea>this.childData).areaName !== undefined) {
        return this.childData as PortalAdapterApi.TopArea;
      }
      return undefined;
    },
  },
  watch: {
    inputData(data) {
      this.childData = data;
    },
  },
  mounted() {
    this.childData = this.inputData;
  },
  methods: {
    countryClicked(countryName: string | undefined, displayText: string) {
      if (countryName === undefined) return;
      this.$emit("country-clicked", countryName, displayText);
    },
    prefectureClicked(prefectureName: string | undefined, displayText: string) {
      if (prefectureName === undefined) return;
      this.$emit("prefecture-clicked", prefectureName, displayText);
    },
    areaClicked(areaData: PortalAdapterApi.TopArea | undefined) {
      if (areaData === undefined) return;
      this.$emit("area-clicked", areaData);
    },
  },
});
